/**
 * MiniLogoBanner — scaled-down THIS + THAT logo for the editor header.
 *
 * Reuses LogoLeft, LogoRight, and PlusSign from the game, composed in
 * the same layout as Board.tsx but scaled so the height matches a
 * teal/orange clue cell rectangle (66px).
 */

import React from 'react';
import LogoLeft from '../../svg/LogoLeft';
import LogoRight from '../../svg/LogoRight';
import PlusSign from '../../svg/PlusSign';

// Game banner layout: ~970px wide × 170px tall
const GAME_W = 970;
const GAME_H = 170;

// Target height: 25% larger than original 33px
const TARGET_H = 41;
const SCALE = TARGET_H / GAME_H;
const TARGET_W = Math.round(GAME_W * SCALE);

const MiniLogoBanner: React.FC = () => (
  <div style={{
    width: TARGET_W,
    height: TARGET_H,
    position: 'relative',
    overflow: 'hidden',
    flexShrink: 0,
  }}>
    <div style={{
      width: GAME_W,
      height: GAME_H,
      transform: `scale(${SCALE})`,
      transformOrigin: 'top left',
      position: 'relative',
    }}>
      {/* Left logo — trapezoid clip hides shadow strip */}
      <div style={{
        position: 'absolute', left: 3, top: 3, width: 564, height: 164,
        clipPath: "path('M0 164V0h564v0.013L400 164H0z')",
      }}>
        <LogoLeft style={{ width: 570, height: 164 }} />
      </div>
      {/* Right logo — trapezoid clip hides shadow strip */}
      <div style={{
        position: 'absolute', left: 403, top: 3, width: 564, height: 164,
        clipPath: "path('M564 0v164H0v-0.013L164 0H564z')",
      }}>
        <LogoRight style={{ left: -6, width: 570, height: 164 }} />
      </div>
      {/* Plus sign */}
      <PlusSign style={{ position: 'absolute', left: 445, top: 45, width: 80, height: 80 }} />
    </div>
  </div>
);

export default React.memo(MiniLogoBanner);
